import { cva } from '@/styled-system/css';

export const textButtonRootRecipe = cva({
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    gap: 'TextButton.gap.label-toIcon',
    focusOutline: true,
  },

  variants: {
    tone: {
      brand: {},
      neutral: {},
      subtle: {},
    },
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {},
    },
    onImpact: {
      true: {},
      false: {},
    },
    isGrouped: {
      true: {
        textAlign: 'center',
        alignSelf: 'stretch',
      },
      false: {},
    },
    size: {
      sm: {},
      md: {},
      lg: {},
    },
    textStyle: {
      'body': {},
      'body-bold': {},
      'body-sm': {},
      'body-sm-bold': {},
    },
  },

  compoundVariants: [
    {
      isGrouped: true,
      size: 'sm',
      css: {
        paddingInline: 'Button.sm.padding.horz',
      },
    },
    {
      isGrouped: true,
      size: 'md',
      css: {
        paddingInline: 'Button.md.padding.horz',
      },
    },
    {
      isGrouped: true,
      size: 'lg',
      css: {
        paddingInline: 'Button.lg.padding.horz',
      },
    },
  ],
});
